import { useLocation } from "react-router-dom";
import type { FinancesNavigationState } from "web_myplann/Finances/Types/FinancesNavigationState";

export const useFinancesNavigationState = (): FinancesNavigationState => {
	const location = useLocation();

	return (location.state ?? {}) as FinancesNavigationState;
};
